// Core
import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  0%, 20% {
    transform: rotate(0deg);
  }
  50%, 70% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const OverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 1rem;
  padding: 2rem;
  text-align: center;
`;

export const IconContainer = styled.div`
  font-size: 4rem;
  animation: ${rotateAnimation} 3s ease-in-out infinite;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.color.rotateDeviceOverlay.iconColor};
  width: 100px;
`;
